import { Flex } from '@/components/Flex/Flex';
import { Modal } from '@/components/Modal';
import { ProductDetail } from '@/components/ProductDetail';
import type { OrderAppCtaType } from '@/graphql/orderApp/api';
import { V12LoanCalculator } from '@/views/PaymentView/components/V12Finance/LoanCalculator';

import {
  Disclaimer,
  V12LoanCalculatorCTAWrapper,
} from './LoanCalculator.style';

import * as M from './messages';

export interface CV12LoanCalculatorModalProps {
  amount: number;
  currency: string;
  isLoading: boolean;
  isOpen: boolean;
  isProcessing: boolean;
  onAddToCart: () => Promise<void>;
  onClose: () => void;
  variantCTA?: OrderAppCtaType;
}

export const V12LoanCalculatorModal = ({
  amount,
  currency,
  isLoading,
  isOpen,
  isProcessing,
  onAddToCart,
  onClose,
  variantCTA,
}: CV12LoanCalculatorModalProps) => {
  const handleAddToCart = () => {
    onClose();
    onAddToCart();
  };
  return (
    <Modal
      data-test-id='ModalV12LoanCalculator'
      isOpen={isOpen}
      maxWidth='xs'
      onClose={onClose}
    >
      <Modal.Header
        data-test-id='ModalV12LoanCalculatorHeader'
        divider={true}
        onClose={onClose}
      >
        Finance Calculator
      </Modal.Header>
      <Modal.Body data-test-id='ModalV12LoanCalculatorBody'>
        <V12LoanCalculator amount={amount} currency={currency} />
        <Flex justifyContent='center'>
          <V12LoanCalculatorCTAWrapper>
            <ProductDetail.CTA
              cta={variantCTA}
              isProcessing={isProcessing}
              loading={isLoading}
              onClick={handleAddToCart}
            />
          </V12LoanCalculatorCTAWrapper>
        </Flex>
        <Disclaimer>
          <M.Disclaimer />
        </Disclaimer>
      </Modal.Body>
    </Modal>
  );
};
V12LoanCalculatorModal.displayName = 'V12LoanCalculatorModal';
